import Cookies from "js-cookie";
import { SelectCountryOption } from "../utils/cookieMessage.utils";

export const DEFAULT_LANGUAGE = "de";
export const DEFAULT_REGION = "at";
export const CI = "Kramp";

export function setLocaleCookie(language, region) {
  const LOCALE_COOKIE_NAME = "KWS_LANGCOUNTRY";
  Cookies.set(
    LOCALE_COOKIE_NAME,
    `${language}-${region}`.toLowerCase(),
    SelectCountryOption
  );
}

export function getLocaleFromUrl() {
  const shopPathName = window.location.pathname.match(/shop-([a-z]{2})\/([a-z]{2})/i);
  // this is for the other formats like the knowledge center that does not have x-region/country
  // https://www.kramp.com/knowledgecenter/gb-en
  const pathName = shopPathName || window.location.pathname.match(/([a-z]{2})-([a-z]{2})/i);

  if (!pathName) {
    return {
      language: DEFAULT_LANGUAGE,
      region: DEFAULT_REGION
    };
  }

  return {
    language: pathName[2],
    region: pathName[1]
  };
}

export function getLanguageAndRegionFromLocale(locale) {
  const [language, region] = locale.toLowerCase().split("-");
  return {
    language,
    region
  };
}
